import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'seo-discover_page_filtered_product_grids_view-view';

/**
 * For Phase 4 Discover Page Improvements.

Tracks when users view each filtered product grid
 */
export function trackSeoDiscoverPageFilteredProductGridsViewView(
  page_url: string,
  section_title2: string,
  position3: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { page_url, section_title2, position3 },
  });
}
